/**
 *  商品、产品 列表页 表头多选框拖拽结束方法
 */
 export const colDrag = {
  created () {
    this.$nextTick(() => {
      this._getTableHeader()
    })
  },
  methods: {

    // 对比本身和存储的右侧表头信息
    _dupuer(arr1, arr2) {//arr1是我们本地的。arr2是返回的所以 name===code判断依据
      if (arr1.length !== arr2.length) return false
      let intersection = arr1.filter(v => arr2.some(x => x.name === v.code))
      return intersection.length === arr1.length
    },
    // 获取表头信息
    _getTableHeader () {
        let res = [] //表头排序的数据 
        let colName = 'vatRegTableColumns'
        if (this.$route.path == '/order/declare-list'){
          colName = 'vatDecTableColumns'
        } else if (this.$route.path == '/order/other-list') {
          colName = 'otherBusinessTableColumns'
        }
        if (localStorage[colName]){ // 取缓存显示
          res = JSON.parse(localStorage.getItem(colName))
        }
        if (!!res && res.length && this._dupuer(this.lineList, res) ) {
            this.lineList.forEach(t => {
              let c = res.find(x => t.code === x.name)
              t.visible = c.visible
              t.sort = c.sort
            })
            this.lineList = this.lineList.sort((a, b) => {
              return a.sort - b.sort
            })
          } else {
            this._putTableHeader()
          }
          this.lineList.forEach(t => {
            if (t.visible) {
              this.chooseLine.push(t.name)
            }
          })
      console.log(this.chooseLine)
          this.chooseCols = []
          this.lineList.forEach(t => {
            const a = this.chooseLine.some(w => {
              return w === t.name
            })
            if (a) {
              this.chooseCols.push(t)
            }
          })
          console.log(this.chooseCols)
    },
    _putTableHeader () {
      let colName = 'vatRegTableColumns'
      if (this.$route.path == '/myDec') {
        colName = 'vatDecTableColumns'
      } else if (this.$route.path == '/otherBusiness') {
        colName = 'otherBusinessTableColumns'
      }
      let customTableColumns = []
      this.lineList.forEach(t => {
        customTableColumns.push({
          name: t.code,
          visible: t.visible,
          sort: t.sort
        })
      })
      let str = JSON.stringify(customTableColumns)
      localStorage.setItem(colName,str)
      
    },
    dragEnd(v) {
      this.chooseCols = []
      this.lineList.forEach((t, index) => {
        t.sort = index
        const a = this.chooseLine.some(w => {
          return w === t.name
        })
        if (a) {
          this.chooseCols.push(t)
        }
      })
      this.key = this.key + 1
      this._putTableHeader()
    }
  },
  watch: {
    chooseLine(valArr) {
      // console.log(valArr)
      this.chooseCols = []
      this.lineList.forEach(t => {
        const a = this.chooseLine.some(w => {
          return w === t.name
        })
        if (a) {
          t.visible = true
          this.chooseCols.push(t)
        } else {
          t.visible = false
        }
      })
      this.key = this.key + 1
      // localStorage['chooseLineDrafts'] = JSON.stringify(valArr)
      this._putTableHeader()
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/showList.js